




import { Component, Prop, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import UrlStorageModule from '../../store/modules/urlStorage.module';

@Component
export default class Logo extends Vue {
  @Prop({ default: '' }) private width;
  @Prop({ default: '' }) private height;

  urlStorageStore: UrlStorageModule = getModule(UrlStorageModule);

  get style() {
    return {
      width: this.width,
      height: this.height,
    };
  }
}
